module.exports = __webpack_public_path__ + "static/phoneScreenshot@2x-63bd5f972c870c73b4b15ef2af2793e6.png";